<div *ngIf="message" class="modal d-block force-to-front" tabindex="-1" role="dialog">
  <div class="modal-dialog custom-alert" role="document">
      <div class="modal-content">
          <div *ngIf="message?.type == 'confirm'" class="modal-body">
              <div class="row">
                  <div class="col-md-12">
                      <div class="scrollable-message-container">
                          <p *ngIf="!message.link" class="text-center confirm-message" data-testid="confirm-dialog-message">{{message.text}}</p>
                          <p *ngIf="message.link" class="text-center confirm-message">
                              {{message.link.textBefore}}<a [href]="message.link.url" target="_blank" rel="noopener" class="invoice-link" data-testid="confirm-dialog-message-link">{{message.link.text}}</a>{{message.link.textAfter}}
                          </p>
                      </div>
                  </div>
              </div>
              <hr>
              <div class="row">
                  <div class="col-md-12">
                      <div class="d-flex justify-content-around">
                        <button class="btn btn-secondary m-2" (click)="message.noFn()" data-testid="confirm-dialog-no">No</button>
                        <button class="btn btn-primary m-2" (click)="message.yesFn()" data-testid="confirm-dialog-yes">Yes</button>
                      </div>
                  </div>
              </div>
          </div>
          <div *ngIf="message?.type == 'alert'" class="modal-body">
              <div class="row">
                  <div class="col-md-12">
                      <div class="scrollable-message-container">
                          <p class="text-center confirm-message">{{message.text}}</p>
                      </div>
                  </div>
              </div>
              <hr>
              <div class="row">
                  <div class="col-md-12">
                      <div class="d-flex justify-content-around">
                        <button class="btn btn-primary m-2" (click)="message.yesFn()" data-testid="confirm-dialog-ok">Ok</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/core/components/confirm-dialog/confirm-dialog.component.html